webpackJsonp([51],{

/***/ 1336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_FileUpload_FileUploadContainer__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_FileUpload_FileUploadContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_FileUpload_FileUploadContainer__);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var user, request, responses, model;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						user = helperMethods.getUser();
						request = [this.$http.get('//ws.controlinn.com/webservice' + '/poll/datacompany/' + user.cmsCompaniesId), this.$http.get('//ws.controlinn.com/webservice' + '/company/search/' + user.cmsCompaniesId)];
						_context.next = 4;
						return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(request);

					case 4:
						responses = _context.sent;

						this.countries = responses[0].data.data.countries;
						this.cities = responses[0].data.data.cities;
						this.languages = responses[0].data.data.languages.map(function (language) {
							var newLanguage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, language);
							newLanguage.isSelected = false;
							return newLanguage;
						});
						model = responses[1].data.data.map(function (data) {
							var newData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data);
							if (!data.url_image) {
								newData.url_image = helperData.preimageUrl;
							}
							return newData;
						});

						this.model = model[0];

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var saveCompany = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						if (!(this.model.language_json.length > 0)) {
							_context2.next = 6;
							break;
						}

						_context2.next = 3;
						return this.$http.post('configuration', this.model);

					case 3:
						this.showNotification('Los datos se guardaron correctamente.', 'success');
						_context2.next = 7;
						break;

					case 6:
						this.showNotification('Debe seleccionar al menos un idioma para los módulos.', 'warning');

					case 7:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function saveCompany() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var helperData = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].data();
var helperMethods = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].methods;

function created() {
	this.loadData();
}

function onUpload(url) {
	this.model.url_image = url;
}

function citiesByCountry() {
	var _this = this;

	var cities = [];
	if (this.model.cms_country_id) {
		cities = this.cities.filter(function (city) {
			return city.cms_country_id === _this.model.cms_country_id;
		});
	}
	return cities;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		FileUploadContainer: __WEBPACK_IMPORTED_MODULE_6__components_shared_FileUpload_FileUploadContainer___default.a
	},
	computed: {
		citiesByCountry: citiesByCountry
	},
	created: created,
	data: function data() {
		return {
			cities: [],
			countries: [],
			languages: [],
			minResolution: 1024,
			maxResolution: 1024,
			model: {
				cms_country_id: 0,
				language_id: '',
				url_image: helperData.preimageUrl,
				language_json: []
			}
		};
	},

	methods: {
		loadData: loadData,
		onUpload: onUpload,
		saveCompany: saveCompany
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */],
	name: 'company'
});

/***/ }),

/***/ 1628:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveCompany($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Idioma del administrador")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.languages,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Idiomas",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.language_id),
      callback: function($$v) {
        _vm.model.language_id = $$v
      },
      expression: "model.language_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "body-border-right": "",
      "pr-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Nombre de empresa")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nombre de empresa"
    },
    model: {
      value: (_vm.model.company_name),
      callback: function($$v) {
        _vm.model.company_name = $$v
      },
      expression: "model.company_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Dirección")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Dirección"
    },
    model: {
      value: (_vm.model.address),
      callback: function($$v) {
        _vm.model.address = $$v
      },
      expression: "model.address"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Correo electrónico")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "email",
      "placeholder": "Nombre de empresa"
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.model.email = $$v
      },
      expression: "model.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pl-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Número tributario")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "number",
      "placeholder": "Número tributario"
    },
    model: {
      value: (_vm.model.ruc),
      callback: function($$v) {
        _vm.model.ruc = $$v
      },
      expression: "model.ruc"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("País")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Ciudad")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "País",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.cms_country_id),
      callback: function($$v) {
        _vm.model.cms_country_id = $$v
      },
      expression: "model.cms_country_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.citiesByCountry,
      "item-text": "name",
      "item-value": "id",
      "disabled": !_vm.model.cms_country_id,
      "hide-details": "",
      "label": "Ciudad",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.city_id),
      callback: function($$v) {
        _vm.model.city_id = $$v
      },
      expression: "model.city_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Web")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Dirección web"
    },
    model: {
      value: (_vm.model.website),
      callback: function($$v) {
        _vm.model.website = $$v
      },
      expression: "model.website"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "body-border-top": "",
      "body-border-bottom": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "body-border-right": "",
      "pr-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "pb-3": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Datos del contacto")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nombre del contacto"
    },
    model: {
      value: (_vm.model.contact_name),
      callback: function($$v) {
        _vm.model.contact_name = $$v
      },
      expression: "model.contact_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pl-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-3": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Correo electrónico")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Teléfono")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "email",
      "placeholder": "Correo electrónico"
    },
    model: {
      value: (_vm.model.contact_email),
      callback: function($$v) {
        _vm.model.contact_email = $$v
      },
      expression: "model.contact_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "phone",
      "placeholder": "Teléfono"
    },
    model: {
      value: (_vm.model.phone),
      callback: function($$v) {
        _vm.model.phone = $$v
      },
      expression: "model.phone"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Logo de la compañía")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pr-3": ""
    }
  }, [_c('file-upload-container', {
    attrs: {
      "image-url": _vm.model.url_image,
      "label-for": 'company-logo',
      "max-resolution": _vm.maxResolution,
      "min-resolution": _vm.minResolution
    },
    on: {
      "upload": _vm.onUpload
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Elegir los idiomas que aparecerán en los módulos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('v-flex', {
      key: language.id,
      attrs: {
        "md2": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox input-languages",
      attrs: {
        "value": language.id,
        "hide-details": ""
      },
      model: {
        value: (_vm.model.language_json),
        callback: function($$v) {
          _vm.model.language_json = $$v
        },
        expression: "model.language_json"
      }
    }, [_c('template', {
      slot: "label"
    }, [_c('img', {
      attrs: {
        "src": language.url_image,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(language.name))])])], 2)], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\t\t\tGuardar\n\t\t\t\t")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1336),
  /* template */
  __webpack_require__(1628),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var FILE_INFORMATION_EVENT = 'file-info';
var FILE_INFORMATION_ERROR = 'file-error';

function onFileSelected(e) {
	var _this = this;

	var minResolution = this.minResolution;
	var file = e.target.files[0];
	if (file) {
		var extArray = file.name.split('.');
		var fileExt = extArray[extArray.length - 1];
		if (this.allowedFiles.indexOf(fileExt.toUpperCase()) === -1) {
			this.$emit(FILE_INFORMATION_ERROR, 'type-not-allowed');
		} else {
			var fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.addEventListener('load', function () {
				var response = file;
				response.result = fileReader.result;
				response.ext = fileExt;
				if (_this.disableValidation) {
					_this.$emit(FILE_INFORMATION_EVENT, response, _this.labelFor);
				} else {
					var tempImage = document.createElement('img');
					tempImage.addEventListener('load', function (imageEvent) {
						var imgWidth = imageEvent.path[0].width;
						var imgHeight = imageEvent.path[0].height;
						if (minResolution > imgWidth || minResolution > imgHeight) {
							_this.$emit(FILE_INFORMATION_ERROR, 'resolution-not-allowed');
						} else {
							_this.$emit(FILE_INFORMATION_EVENT, response, _this.labelFor);
						}
					});
					tempImage.src = fileReader.result;
				}
			});
		}
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'file-upload',
	props: {
		allowedFiles: {
			type: Array,
			default: function _default() {
				return ['JPG', 'JPEG', 'PNG', 'GIF'];
			}
		},
		disableValidation: {
			type: Boolean,
			default: false
		},
		imageUrl: {
			type: String,
			required: true
		},
		labelFor: {
			type: [String, Number],
			required: true
		},
		maxResolution: {
			type: Number,
			default: 500
		},
		minResolution: {
			type: Number,
			default: 500
		},
		previewImage: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		onFileSelected: onFileSelected
	}
});

/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FileUpload__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FileUpload__);
//
//
//
//
//
//
//
//




var ON_UPLOAD = 'upload';

function fileError(type) {
	if (type === 'type-not-allowed') {
		this.showNotification('El formato de imagen que intenta subir no es el correcto', 'error');
	} else {
		this.showNotification('La resolución de la imagen que intenta subir no es la correcta', 'error');
	}
}

function fileInfo(file, labelFor) {
	var _this = this;

	var imageUrl = '//ws.controlinn.com/webservice' + '/image/one-upload';
	this.$http.post('' + imageUrl, { type: file.ext, image: file.result }).then(function (response) {
		_this.$emit(ON_UPLOAD, response.data.data[0], labelFor);
	});
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'file-upload-container',
	components: {
		FileUpload: __WEBPACK_IMPORTED_MODULE_1__FileUpload___default.a
	},
	props: {
		allowedFiles: {
			type: Array,
			default: function _default() {
				return ['JPG', 'JPEG', 'PNG', 'GIF'];
			}
		},
		disableValidation: {
			type: Boolean,
			default: false
		},
		labelFor: {
			type: [String, Number],
			required: true
		},
		imageUrl: {
			type: String,
			required: true
		},
		maxResolution: {
			type: Number,
			default: 500
		},
		minResolution: {
			type: Number,
			default: 500
		},
		previewImage: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		fileError: fileError,
		fileInfo: fileInfo
	},
	mixins: __WEBPACK_IMPORTED_MODULE_0__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".file-upload-container[data-v-606477c4]{-ms-flex-line-pack:center;align-content:center;background-color:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);height:100%;padding:16px 0;width:100%}.file-upload-container[data-v-606477c4],.upload-file[data-v-606477c4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.upload-file[data-v-606477c4]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.upload-file .allowed-files[data-v-606477c4]{color:#6d808c;font-family:San Francisco Display;font-size:10px;height:12px;letter-spacing:0;text-align:center;width:83px}.upload-file .camera-button[data-v-606477c4]{background-color:#04abe3;border-radius:5px;cursor:pointer;height:20px;margin-bottom:5px;text-align:center;width:36px}.upload-file .default-image[data-v-606477c4]{margin-bottom:16px}.upload-file .min-text[data-v-606477c4]{color:#6d808c;font-family:San Francisco Display;font-size:11px;font-weight:600;height:14px;letter-spacing:-.1px;width:auto}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/FileUpload/FileUpload.vue"],"names":[],"mappings":"AACA,wCACE,0BAA2B,AACvB,qBAAsB,AAC1B,sBAAwB,AACxB,8CAAmD,AAC3C,sCAA2C,AAInD,YAAa,AAIb,eAAgB,AAChB,UAAY,CACb,AACD,sEAVE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAEd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAkBjC,AAdD,8BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAI5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAIhC,AACD,6CACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,YAAa,AACb,iBAAqB,AACrB,kBAAmB,AACnB,UAAY,CACf,AACD,6CACI,yBAA0B,AAC1B,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,UAAY,CACf,AACD,6CACI,kBAAoB,CACvB,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,qBAAuB,AACvB,UAAY,CACf","file":"FileUpload.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.file-upload-container[data-v-606477c4] {\n  -ms-flex-line-pack: center;\n      align-content: center;\n  background-color: white;\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 16px 0;\n  width: 100%;\n}\n.upload-file[data-v-606477c4] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.upload-file .allowed-files[data-v-606477c4] {\n    color: #6d808c;\n    font-family: 'San Francisco Display';\n    font-size: 10px;\n    height: 12px;\n    letter-spacing: -0px;\n    text-align: center;\n    width: 83px;\n}\n.upload-file .camera-button[data-v-606477c4] {\n    background-color: #04abe3;\n    border-radius: 5px;\n    cursor: pointer;\n    height: 20px;\n    margin-bottom: 5px;\n    text-align: center;\n    width: 36px;\n}\n.upload-file .default-image[data-v-606477c4] {\n    margin-bottom: 16px;\n}\n.upload-file .min-text[data-v-606477c4] {\n    color: #6d808c;\n    font-family: 'San Francisco Display';\n    font-size: 11px;\n    font-weight: 600;\n    height: 14px;\n    letter-spacing: -0.1px;\n    width: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(934);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("60244ac6", content, true);

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(943),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-606477c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(944),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 943:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload-container"
  }, [_c('label', {
    staticClass: "upload-file",
    attrs: {
      "for": _vm.labelFor
    }
  }, [(_vm.previewImage) ? _c('img', {
    staticClass: "default-image",
    attrs: {
      "src": _vm.imageUrl,
      "alt": "default logo",
      "width": "46.8",
      "height": "38"
    }
  }) : _c('a', {
    attrs: {
      "href": _vm.imageUrl,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Open File")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.disableValidation) ? _c('span', {
    staticClass: "min-text"
  }, [_vm._v("MIN. " + _vm._s(_vm.minResolution) + "x" + _vm._s(_vm.minResolution))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "allowed-files"
  }, [_vm._v(_vm._s(_vm.allowedFiles.join(', ')))]), _vm._v(" "), _c('input', {
    attrs: {
      "id": _vm.labelFor,
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.onFileSelected
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera-button"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/camera.png",
      "alt": "camera button",
      "width": "13.3",
      "height": "10.8"
    }
  })])
}]}

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('file-upload', {
    attrs: {
      "label-for": _vm.labelFor,
      "image-url": _vm.imageUrl,
      "min-resolution": _vm.minResolution,
      "disable-validation": _vm.disableValidation,
      "max-resolution": _vm.maxResolution,
      "preview-image": _vm.previewImage,
      "allowed-files": _vm.allowedFiles
    },
    on: {
      "file-info": _vm.fileInfo,
      "file-error": _vm.fileError
    }
  })
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/51.aafae7113f361c1c3048.js